<script setup lang="ts">
const { productId } = defineProps<{
  productId: string;
}>();

const { clearRefererData, refererPartnerUrl, refererPartnerName } =
  // most of this logic is route-query based so we compute things onMounted and are okay with the reactivity loss
  // eslint-disable-next-line vue/no-setup-props-reactivity-loss
  useRefererPartnerData(productId);

const { t } = useI18n();
</script>

<template>
  <BaseNuxtLinkButton
    v-if="refererPartnerUrl"
    :link-path="refererPartnerUrl"
    target="_self"
    color-scheme="text-only"
    class="back-to-referer"
    @click="clearRefererData"
  >
    {{
      refererPartnerName
        ? t("checkout.returnToPartner", {
            PLACEHOLDER_partnerName: refererPartnerName,
          })
        : t("checkout.return")
    }}
  </BaseNuxtLinkButton>
</template>
